export default function Acoes() {
  return (
    <>
      <section className="section parallax bg2" id="divider2">
        <div className="text-center">
          <hr className="divider" />
          <h1 className="h1">NOSSAS AÇÕES</h1>
          <hr className="divider" />
        </div>
      </section>
      <section className="section static-dark" id="atuacao">
        <div className="container">
          <h2 className="h2">NOSSAS AÇÕES</h2>
          <div className="row justify-content-center">
            <div className="col-sm-auto text-center">
              <div className="flip-card">
                <div className="flip-card-inner">
                  <div className="flip-card-front bg-secondary rounded">
                    <picture className="figure">
                      <source
                        srcSet="/media/figs/calltoarms.webp"
                        type="image/webp"
                      />
                      <img
                        src="/media/figs/calltoarms.jpeg"
                        alt="Call to Arms"
                        className="flip-card-img figure-img img-fluid rounded"
                      />
                    </picture>
                    <div className="flip-card-front-title">
                      <h3 className="h3">CALL TO ARMS</h3>
                    </div>
                    <div className="flip-card-front-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-hand-index-thumb"
                        viewBox="0 0 16 16"
                      >
                        <path d="M6.75 1a.75.75 0 0 1 .75.75V8a.5.5 0 0 0 1 0V5.467l.086-.004c.317-.012.637-.008.816.027.134.027.294.096.448.182.077.042.15.147.15.314V8a.5.5 0 0 0 1 0V6.435l.106-.01c.316-.024.584-.01.708.04.118.046.3.207.486.43.081.096.15.19.2.259V8.5a.5.5 0 1 0 1 0v-1h.342a1 1 0 0 1 .995 1.1l-.271 2.715a2.5 2.5 0 0 1-.317.991l-1.395 2.442a.5.5 0 0 1-.434.252H6.118a.5.5 0 0 1-.447-.276l-1.232-2.465-2.512-4.185a.517.517 0 0 1 .809-.631l2.41 2.41A.5.5 0 0 0 6 9.5V1.75A.75.75 0 0 1 6.75 1zM8.5 4.466V1.75a1.75 1.75 0 1 0-3.5 0v6.543L3.443 6.736A1.517 1.517 0 0 0 1.07 8.588l2.491 4.153 1.215 2.43A1.5 1.5 0 0 0 6.118 16h6.302a1.5 1.5 0 0 0 1.302-.756l1.395-2.441a3.5 3.5 0 0 0 .444-1.389l.271-2.715a2 2 0 0 0-1.99-2.199h-.581a5.114 5.114 0 0 0-.195-.248c-.191-.229-.51-.568-.88-.716-.364-.146-.846-.132-1.158-.108l-.132.012a1.26 1.26 0 0 0-.56-.642 2.632 2.632 0 0 0-.738-.288c-.31-.062-.739-.058-1.05-.046l-.048.002zm2.094 2.025z" />
                      </svg>
                    </div>
                  </div>
                  <div className="flip-card-back rounded row align-items-center static-light">
                    <div className="col-md">
                      <h3 className="h3">CALL TO ARMS</h3>
                      <p>
                        Viagens missionárias, onde os Riders vão até alguma cidade, 
                        igreja, evento, espalhando o amor e a mensagem de cristo pelo caminho.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-auto text-center">
              <div className="flip-card">
                <div className="flip-card-inner">
                  <div className="flip-card-front bg-secondary rounded">
                    <picture className="figure">
                      <source
                        srcSet="/media/figs/Lighthouse 2024.webp"
                        type="image/webp"
                      />
                      <img
                        src="/media/figs/Lighthouse 2024.webp"
                        alt="Lighthouse"
                        className="flip-card-img figure-img img-fluid rounded"
                      />
                    </picture>
                    <div className="flip-card-front-title">
                      <h3 className="h3">LIGHTHOUSE</h3>
                    </div>
                    <div className="flip-card-front-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-hand-index-thumb"
                        viewBox="0 0 16 16"
                      >
                        <path d="M6.75 1a.75.75 0 0 1 .75.75V8a.5.5 0 0 0 1 0V5.467l.086-.004c.317-.012.637-.008.816.027.134.027.294.096.448.182.077.042.15.147.15.314V8a.5.5 0 0 0 1 0V6.435l.106-.01c.316-.024.584-.01.708.04.118.046.3.207.486.43.081.096.15.19.2.259V8.5a.5.5 0 1 0 1 0v-1h.342a1 1 0 0 1 .995 1.1l-.271 2.715a2.5 2.5 0 0 1-.317.991l-1.395 2.442a.5.5 0 0 1-.434.252H6.118a.5.5 0 0 1-.447-.276l-1.232-2.465-2.512-4.185a.517.517 0 0 1 .809-.631l2.41 2.41A.5.5 0 0 0 6 9.5V1.75A.75.75 0 0 1 6.75 1zM8.5 4.466V1.75a1.75 1.75 0 1 0-3.5 0v6.543L3.443 6.736A1.517 1.517 0 0 0 1.07 8.588l2.491 4.153 1.215 2.43A1.5 1.5 0 0 0 6.118 16h6.302a1.5 1.5 0 0 0 1.302-.756l1.395-2.441a3.5 3.5 0 0 0 .444-1.389l.271-2.715a2 2 0 0 0-1.99-2.199h-.581a5.114 5.114 0 0 0-.195-.248c-.191-.229-.51-.568-.88-.716-.364-.146-.846-.132-1.158-.108l-.132.012a1.26 1.26 0 0 0-.56-.642 2.632 2.632 0 0 0-.738-.288c-.31-.062-.739-.058-1.05-.046l-.048.002zm2.094 2.025z" />
                      </svg>
                    </div>
                  </div>
                  <div className="flip-card-back rounded row align-items-center static-light">
                    <div className="col-md">
                      <h3 className="h3">LIGHTHOUSE</h3>
                      <p>
                        Reunião semanal de confraternização entre os membros e
                        amigos. Onde também é feito um estudo bíblico, comunhão
                        e cuidado entre os membros e as pessoas presentes.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-auto text-center">
              <div className="flip-card">
                <div className="flip-card-inner">
                  <div className="flip-card-front bg-secondary rounded">
                    <picture className="figure">
                      <source
                        srcSet="/media/figs/Fire Road.webp"
                        type="image/webp"
                      />
                      <img
                        src="/media/figs/Fire Road.webp"
                        alt="Fire Road"
                        className="flip-card-img figure-img img-fluid rounded"
                      />
                    </picture>
                    <div className="flip-card-front-title">
                      <h3 className="h3">FIRE ROAD</h3>
                    </div>
                    <div className="flip-card-front-icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-hand-index-thumb"
                        viewBox="0 0 16 16"
                      >
                        <path d="M6.75 1a.75.75 0 0 1 .75.75V8a.5.5 0 0 0 1 0V5.467l.086-.004c.317-.012.637-.008.816.027.134.027.294.096.448.182.077.042.15.147.15.314V8a.5.5 0 0 0 1 0V6.435l.106-.01c.316-.024.584-.01.708.04.118.046.3.207.486.43.081.096.15.19.2.259V8.5a.5.5 0 1 0 1 0v-1h.342a1 1 0 0 1 .995 1.1l-.271 2.715a2.5 2.5 0 0 1-.317.991l-1.395 2.442a.5.5 0 0 1-.434.252H6.118a.5.5 0 0 1-.447-.276l-1.232-2.465-2.512-4.185a.517.517 0 0 1 .809-.631l2.41 2.41A.5.5 0 0 0 6 9.5V1.75A.75.75 0 0 1 6.75 1zM8.5 4.466V1.75a1.75 1.75 0 1 0-3.5 0v6.543L3.443 6.736A1.517 1.517 0 0 0 1.07 8.588l2.491 4.153 1.215 2.43A1.5 1.5 0 0 0 6.118 16h6.302a1.5 1.5 0 0 0 1.302-.756l1.395-2.441a3.5 3.5 0 0 0 .444-1.389l.271-2.715a2 2 0 0 0-1.99-2.199h-.581a5.114 5.114 0 0 0-.195-.248c-.191-.229-.51-.568-.88-.716-.364-.146-.846-.132-1.158-.108l-.132.012a1.26 1.26 0 0 0-.56-.642 2.632 2.632 0 0 0-.738-.288c-.31-.062-.739-.058-1.05-.046l-.048.002zm2.094 2.025z" />
                      </svg>
                    </div>
                  </div>
                  <div className="flip-card-back rounded row align-items-center static-light">
                    <div className="col-md">
                      <h3 className="h3">FIRE ROAD</h3>
                      <p>
                        Visita as igrejas locais, independente da instituição,
                        onde os Riders vão a convite de amigos ou líderes para
                        um momento de culto e celebração a Deus.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="ppv" className="pt-5">
            <div className="bg-light px-4 py-4 mt-5 text-dark border rounded">
              <div className="row">
                <div className="col-lg-6 fs-5">
                  <h3 className="h3">PILOTANDO PARA VIDA</h3>
                  <p>
                    O Pilotando para Vida (PPV) é um curso gratuito de pilotagem
                    defensiva de motociclistas, que visa dotar seus
                    participantes de conhecimentos teóricos e práticos, que
                    possibilitem um pilotar mais seguro nos deslocamentos
                    diários.
                  </p>
                  <p className="text-start">
                    <a
                      className="btn btn-primary"
                      target="_blank"
                      href="https://forms.gle/aXDmkphS8SSRMoXPA"
                      rel="noreferrer"
                    >
                      Inscreva-se
                    </a>
                  </p>
                </div>
                <div className="col-lg-6 text-center">
                  <video id="ppv-video" controls className="border rounded">
                    <source src="/video/video2.mp4" type="video/mp4" />
                    Seu navegador não possui suporte a vídeo!
                  </video>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
